import styled from 'styled-components'

export const FooterSection = styled.footer
    `
    text-align: center;
    padding :15px 0;
    color:#888;
    background:#e2e2e2`
